import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_4164597463 from "../../../../../packages/component/src/components/balloon/demo/demo1.js?loadDemo";
import legacyImportDemo_787634036 from "../../../../../packages/component/src/components/balloon/demo/demo2.js?loadDemo";
import legacyImportDemo_208316949 from "../../../../../packages/component/src/components/balloon/demo/demo3.js?loadDemo";
import legacyImportDemo_3813452210 from "../../../../../packages/component/src/components/balloon/demo/demo4.js?loadDemo";
import legacyImportDemo_3228331603 from "../../../../../packages/component/src/components/balloon/demo/demo5.js?loadDemo";
import legacyImportDemo_2871938288 from "../../../../../packages/component/src/components/balloon/demo/demo6.js?loadDemo";
import legacyImportDemo_1239421329 from "../../../../../packages/component/src/components/balloon/demo/demo7.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_4164597463,
  legacyImportDemo_787634036,
  legacyImportDemo_208316949,
  legacyImportDemo_3813452210,
  legacyImportDemo_3228331603,
  legacyImportDemo_2871938288,
  legacyImportDemo_1239421329,
  React
};